import React from "react";
import DashboardCard from "../../../components/DashboardCard";
import { useHistory } from "react-router-dom";
import { useRecoilState, useRecoilValue } from "recoil";
import { permissionsSelector } from "../../Login/selectors/permissionSelector";
import { ReceiptPercentIcon } from "@heroicons/react/24/solid";
import { PERMISSIONS } from "../../PermissionsConstants";
import {
  mainSelectedTab,
  permittedTabs,
} from "../../CarrierAgreementMgmt/atoms";
import { RedirectTo } from "../../../routes/RedirectTo";
import useGetAllVendorInvoiceCount from "../../CarrierAgreementMgmt/VendorInvoice/InvoiceCapture/hooks/useGetVendorInvoiceCount";

const NewVendorInvoiceCard = () => {
  const modulePermission = PERMISSIONS.permission_vendorinvoice_view;
  const userPermissions = useRecoilValue(permissionsSelector);

  const history = useHistory();

  const [, setSelectedIndex] = useRecoilState(mainSelectedTab);
  const [usersTabs] = useRecoilState(permittedTabs);
  const { data: allVendorInvoiceCount } = useGetAllVendorInvoiceCount();

  return (
    <div
      className="p-2 pr-4 bg-white text-primary rounded-lg animate-fade-in-down2 shadow-md hover:text-white hover:bg-deletebtn"
      onClick={() => {
        if (userPermissions.includes(modulePermission)) {
          RedirectTo({
            urlPath: "/vendortab/invoice",
            history: history,
            usersTabs: usersTabs,
            setSelectedIndex: setSelectedIndex,
          });
        }
      }}
    >
      <DashboardCard
        text="Vendor Invoice"
        count={allVendorInvoiceCount}
        image={
          <ReceiptPercentIcon className="text-white bg-deletebtn rounded-md h-7 w-7 p-1" />
        }
        hasAccess={userPermissions.includes(modulePermission)}
      />
    </div>
  );
};

export default NewVendorInvoiceCard;
